import { useState, useCallback } from 'react';

interface AuthHook {
  refreshToken: () => Promise<boolean>;
}

export const useAuth = (): AuthHook => {
  const [isRefreshing, setIsRefreshing] = useState(false);

  const refreshToken = useCallback(async (): Promise<boolean> => {
    if (isRefreshing) return false;

    try {
      setIsRefreshing(true);
      const response = await fetch(`${import.meta.env.VITE_REACT_APP_CORE_ENGINE_URL}/user/refreshToken`, {
        method: 'POST',
        headers: {
          'accept': 'application/json, text/plain, */*',
          'content-type': 'application/json',
        },
        body: JSON.stringify({}),
        credentials: 'include',
      });

      if (!response.ok) {
        throw new Error('Failed to refresh token');
      }

      return true;
    } catch (error) {
      console.error('Error refreshing token:', error);
      return false;
    } finally {
      setIsRefreshing(false);
    }
  }, [isRefreshing]);

  return {
    refreshToken,
  };
}; 